export let LABLES = {
    EMAIL: "Email Address",
    PASSWORD: "Password",
    NEW_PASSWORD: "New Password",
    CONFIRM_PASSWORD: "Confirm New Password"
};

export let NAMES = {
    [LABLES.EMAIL]: "email",
    [LABLES.PASSWORD]: "password",
    [LABLES.NEW_PASSWORD]: "newPassword",
    [LABLES.CONFIRM_PASSWORD]: "confirmPassword"
};

export let PLACEHOLDERS = {
    [LABLES.EMAIL]: "Email Address",
    [LABLES.PASSWORD]: "•••••••••",
    [LABLES.NEW_PASSWORD]: "•••••••••",
    [LABLES.CONFIRM_PASSWORD]: "•••••••••"
};
